import { inject, Injectable, signal } from '@angular/core';
import { AuthService } from '@services/auth/auth.service';
import { CurrentUserService } from '@services/current-user/current-user';
import { CompanyService } from '@services/company/company.service';
import { LfMenuItem } from '@leafio/ui/layout';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  protected authService = inject(AuthService);
  protected currentUser = inject(CurrentUserService);
  protected companyService = inject(CompanyService);

  topItems = signal<LfMenuItem[]>([
    {
      name: '',
      url: '/',
      iconName: 'menu/logo-leafio',
      className: 'lf-menu-item_with-leafio-logo',
    },
    {
      name: '',
      url: 'planograms',
      iconName: 'menu/planogram',
    },
  ]);
  bottomItems = signal<LfMenuItem[]>([
    {
      name: 'main_menu.user',
      url: null,
      iconName: 'menu/user',
      children: [
        {
          name: 'NAVIGATION.authorization',
          icon: 'log_out',
          accent: 'danger',
          url: null,
          onClick: () => this.logout(),
        },
      ],
      submenuHeader: {
        url: 'user',
        name: this.currentUser.user()?.fullName || '',
        description: this.currentUser.user()?.email || '',
      },
    },
  ]);

  logout() {
    void this.authService.toLoginPage(this.companyService.name, true);
  }
}
